import { Link } from "react-router-dom";
import { Reveal, SectionHead, ArrowLink } from "../Bits";

const Gallery = ({ installations }) => (
  <section data-testid="home-gallery" className="bg-white py-20 lg:py-32">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <Reveal>
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <SectionHead
            eyebrow="Installations"
            title="Built to transform training spaces"
            copy="Recent surface and wall-padding installations across disciplines and facility types."
          />
          <ArrowLink to="/installations" data-testid="gallery-view-all">
            View all installations
          </ArrowLink>
        </div>
      </Reveal>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:mt-20 lg:grid-cols-3">
        {installations.slice(0, 6).map((p, i) => (
          <Reveal key={p.slug} delay={(i % 3) * 0.08}>
            <Link
              to="/installations"
              data-testid={`gallery-item-${p.slug}`}
              className="group block"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-[#F5F5F2]">
                <img
                  src={p.image}
                  alt={`${p.sport} installation`}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.05]"
                />
                <span className="mako-label absolute left-0 top-0 bg-white/95 px-4 py-2.5 text-[#0F4C81]">
                  {p.sport}
                </span>
              </div>
              <div className="mt-5 min-h-[64px]">
                <p className="font-display text-sm font-semibold text-[#111111]">{p.facility}</p>
                <p className="mako-label mt-2 text-[#7A7F85]">
                  {(p.products || []).join(" · ")}
                </p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
